import React from "react";
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

class SearchField extends React.Component {

    render() {
        const {field, classes, handleSearchFieldChange} = this.props;

        if (field.fieldType === "sortonly") {
            return (null);
        }

        if (field.fieldType === "checkbox") {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={field.selectedValue.length > 0}
                            value={field.searchValue}
                            color="primary"
                            onChange={(e) => handleSearchFieldChange(field.filterId, e.target.checked ? e.target.value : "")}
                        />
                    }
                    labelPlacement="end"
                    label={field.label}
                />);
        }

        if (field.fieldType === "textbox") {
            return (
                <TextField
                    className={classes.formControl}
                    id="standard-name"
                    label={field.label}
                    name={field.filterId}
                    value={field.selectedValue}
                    onChange={(e) => handleSearchFieldChange(field.filterId, e.target.value)}
                    margin="none"/>);
        }
        if (field.fieldType === "select") {
            return (
                <FormControl className={classes.formControl} margin="none">
                    <InputLabel>{field.label}</InputLabel>
                    <Select id="standard-name"
                            value={field.selectedValue}
                            onChange={(e) => handleSearchFieldChange(field.filterId, e.target.value)}
                            name={field.filterId}
                            margin="none">
                        {
                            field.searchValues.map((element, index) => {
                                return (
                                    <MenuItem disabled={element.disabled} key={"mu-" + index}
                                              value={element.value}>{element.label}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </FormControl>);
        }

        if (field.fieldType === "multiselect") {
            return (
                <FormControl className={classes.formControl} margin="none">
                    <InputLabel>{field.label}</InputLabel>
                    <Select id="standard-name"
                            multiple={true}
                            value={field.selectedValues}
                            onChange={(e) => handleSearchFieldChange(field.filterId, e.target.value)}
                            name={field.filterId}
                            renderValue={selected => {
                                return (field.searchValues.filter(filter => field.selectedValues.indexOf(filter.value) >= 0)
                                    .map((element) => {
                                        return element.label;
                                    })).join(", ");

                            }
                            }
                            margin="none">
                        {
                            field.searchValues.map((element, index) => {
                                if (element.disabled) {
                                    return (
                                        <MenuItem disabled={element.disabled} key={"mu-" + index}
                                                  value={element.value}>{element.label}</MenuItem>
                                    );
                                }

                                return (
                                    <MenuItem key={"mu-" + index} value={element.value}>
                                        <Checkbox checked={field.selectedValues.indexOf(element.value) > -1}/>
                                        <ListItemText primary={element.label}/>
                                    </MenuItem>
                                )
                            })
                        }
                    </Select>
                </FormControl>);
        }
        return (<React.Fragment>Undefined field type {field.fieldType}</React.Fragment>);
    }
}

export default SearchField;